import React, { useState } from 'react';
import { LockIcon, LogOutIcon } from 'lucide-react';
import { useStore } from '../contexts/StoreContext';
import { LeadsPanel } from '../components/admin/LeadsPanel';
import { VehiclesPanel } from '../components/admin/VehiclesPanel';
import { BrandsPanel } from '../components/admin/BrandsPanel';
import { BannersPanel } from '../components/admin/BannersPanel';
import { HistoryPanel } from '../components/admin/HistoryPanel';
import { SettingsPanel } from '../components/admin/SettingsPanel';
type Tab = 'consultas' | 'unidades' | 'marcas' | 'banners' | 'historial' | 'ajustes';
const tabs: {
  id: Tab;
  label: string;
}[] = [{
  id: 'consultas',
  label: 'Consultas'
}, {
  id: 'unidades',
  label: 'Unidades'
}, {
  id: 'marcas',
  label: 'Marcas y condiciones'
}, {
  id: 'banners',
  label: 'Banners'
}, {
  id: 'historial',
  label: 'Historial'
}, {
  id: 'ajustes',
  label: 'Ajustes'
}];
const SESSION_KEY = 'vcars-admin-session';
export function Admin() {
  const {
    settings,
    leads
  } = useStore();
  const [authed, setAuthed] = useState(() => sessionStorage.getItem(SESSION_KEY) === '1');
  const [pin, setPin] = useState('');
  const [error, setError] = useState('');
  const [tab, setTab] = useState<Tab>('consultas');
  if (!authed) {
    return <div className="container-x grid min-h-[70vh] place-items-center py-12" data-id="element-1180" data-mp="3boy4ysqb35ae">
        <form onSubmit={e => {
        e.preventDefault();
        if (pin === settings.adminPin) {
          sessionStorage.setItem(SESSION_KEY, '1');
          setAuthed(true);
        } else {
          setError('Clave incorrecta.');
        }
      }} className="card w-full max-w-sm p-6" data-id="element-1181" data-mp="36nqwergca22o">
          <LockIcon className="h-6 w-6 text-neon" aria-hidden data-id="element-1182" data-mp="2nyc2ri2zgf8b" />
          <h1 className="mt-3 font-display text-xl font-bold" data-id="element-1183" data-mp="2iyg663wm7q2s">Panel de administración</h1>
          <p className="mt-1 text-sm text-mist" data-id="element-1184" data-mp="2j0afsm2frvrk">Ingresá la clave del panel. Clave inicial de demostración: <span className="font-mono text-white" data-id="element-1185" data-mp="2e1pfkmn6pc34">vcars-admin</span></p>
          <label htmlFor="adm-pin" className="label mt-5" data-id="element-1186" data-mp="24a63jo1zglmx">Clave</label>
          <input id="adm-pin" type="password" className="input" value={pin} onChange={e => setPin(e.target.value)} autoComplete="current-password" autoFocus data-id="element-1187" data-mp="29b3uap126o01" />
          {error && <p className="mt-2 text-xs text-danger" role="alert" data-id="element-1188" data-mp="1zco54rlldot6">{error}</p>}
          <button type="submit" className="btn btn-primary mt-4 w-full" data-id="element-1189" data-mp="1zeqr90jmixsm">Ingresar</button>
        </form>
      </div>;
  }
  const newLeads = leads.filter(l => l.status === 'recibida').length;
  return <div className="container-x py-8" data-id="element-1190" data-mp="2s364pin3x81u">
      <div className="flex items-center justify-between gap-4" data-id="element-1191" data-mp="2dd799nmxsaq2">
        <h1 className="font-display text-2xl font-black tracking-tight sm:text-3xl" data-id="element-1192" data-mp="2dakylf4r1f3m">Administración</h1>
        <button onClick={() => {
        sessionStorage.removeItem(SESSION_KEY);
        setAuthed(false);
        setPin('');
      }} className="btn btn-ghost h-9" data-id="element-1193" data-mp="36132gidarki3">
          <LogOutIcon className="h-4 w-4" aria-hidden data-id="element-1194" data-mp="zckmrdrh1nif" /> Salir
        </button>
      </div>

      <div className="-mx-4 mt-6 overflow-x-auto px-4 sm:mx-0 sm:px-0" data-id="element-1195" data-mp="udr9nmg3jyis">
        <div role="tablist" aria-label="Secciones del panel" className="flex min-w-max gap-1 border-b border-line" data-id="element-1196" data-mp="ubn5r4i76zii">
          {tabs.map(t => <button key={t.id} role="tab" aria-selected={tab === t.id} onClick={() => setTab(t.id)} className={`relative px-4 py-3 text-sm font-medium transition-colors duration-150 ${tab === t.id ? 'text-white' : 'text-mist hover:text-white'}`} data-id="element-1197" data-mp="143apskcfde9y">
              {t.label}
              {t.id === 'consultas' && newLeads > 0 && <span className="ml-1.5 rounded-full bg-neon px-1.5 py-0.5 text-[10px] font-bold text-white" data-id="element-1198" data-mp="lcjhzn835vxo">{newLeads}</span>}
              {tab === t.id && <span className="absolute inset-x-2 -bottom-px h-0.5 bg-neon" aria-hidden data-id="element-1199" data-mp="20s08gcvvmawz" />}
            </button>)}
        </div>
      </div>

      <div className="mt-6" role="tabpanel" data-id="element-1200" data-mp="2s2wm1o13vjci">
        {tab === 'consultas' && <LeadsPanel data-id="element-1201" data-mp="2s4r855o45hi6" />}
        {tab === 'unidades' && <VehiclesPanel data-id="element-1202" data-mp="2w387v457fppk" />}
        {tab === 'marcas' && <BrandsPanel data-id="element-1203" data-mp="2w62ritge96hx" />}
        {tab === 'banners' && <BannersPanel data-id="element-1204" data-mp="312tfe2yfx6dw" />}
        {tab === 'historial' && <HistoryPanel data-id="element-1205" data-mp="3155veakn16ob" />}
        {tab === 'ajustes' && <SettingsPanel data-id="element-1206" data-mp="362fu6gtx2uot" />}
      </div>
    </div>;
}